<template>
    <div
        class="o-compass compass"
        @click="onCompassClick"
    >
        <svg-icon
            original
            name="icons/compass-off"
            class="compass__inner"
            :style="{'transform': 'rotate(' + value + 'deg)'}"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'OCompass',
    props: {
        value: {
            type: Number,
            default: 0
        }
    },
    computed:{
        ...mapState({
            isCompassEnabled: state => state.isCompassEnabled
        }),
    },
    methods:{
        onCompassClick(){
            this.$store.commit('setCompassState', !this.isCompassEnabled);
        }
    }
}
</script>

<style lang="scss">
@import "o-compass";
</style>
